<template>
  <section class="ambassadors-tile" :id="$options.filters.normalizeString(item.anchor ? item.anchor : item.title)">
    <div class="ambassadors">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 content" :class="{ '-right': item.side !== 'right' }">
            <Observer name="fade-up" class="info" @enter="enter">
              <span class="headline h3" v-if="item.headline" v-html="item.headline" />
              <h2 class="title" v-if="item.title" v-html="item.title"></h2>
              <span class="subtitle h3" v-if="item.subtitle" v-html="item.subtitle" />
              <p class="text" v-if="item.text" v-html="item.text" />
              <router-link :to="localizedUrl + item.ctaLink" class="link-light font-btn" v-text="item.ctaText" v-if="item.ctaLink && !item.ctaLink.includes('http') && item.ctaText"></router-link>
              <a :href="item.ctaLink" class="link-light font-btn" v-text="item.ctaText" v-if="item.ctaLink && item.ctaLink.includes('http') && item.ctaText"></a>
              <button class="btn-watch font-btn" @click="playVideo" ref="btn" v-if="item.video">
                <i class="btn-autoPlay -paused"></i> {{ $t('Watch the video') }}
              </button>
            </Observer>
          </div>
        </div>
      </div>
      <Observer name="fade-up" :class="{ '-left': item.side !== 'right' }">
        <div class="visual" :class="{'-hasBorder': item.hasBorder}" @mouseover="toggleSlider" @mouseout="toggleSlider">
          <button v-if="products && products.length > 0" type="button" @click="onOpenModal" class="btn-preview font-btn">
            <i class="icon-cart"></i>
            <span>{{ $t('Watch preview') }}</span>
          </button>
          <div class="slide" ref="slides" v-for="(slide, i) in images" :key="i" :class="{'-active': i === currentSlide}">
            <lazy-picture :item="slide" desktop-ratio="1" mobile-ratio="1.25"></lazy-picture>
          </div>
        </div>
      </Observer>
    </div>
    <ModalProduct :is-open="openModalProduct" :data="{image: images[0].image, products: products}" @close="onCloseModal" />
    <div ref="pop" class="player" :class="{'-show': played}" v-if="item.video" :tabindex="played ? 0 : -1" v-bsl="played">
      <button type="button" ref="close" @click="pauseVideo" :aria-label="$t('Close')" class="close" :tabindex="played ? 0 : -1"><i class="icon-close"></i></button>
      <NoSSR>
        <Observer name="fade-up" @leave="leave">
          <vue-plyr ref="plyr" :options="plyrOption" :class="{ 'hide-controls': !hideInfo }">
            <video :src="(injected && item.video.url) ? item.video.url : ''" crossorigin="anonymous" playsinline>
              <track v-if="item.subtitle && item.subtitle.src && item.subtitle.srclang" kind="captions" :label="item.subtitle.label" :srclang="item.subtitle.srclang" :src="item.subtitle.src" default />
            </video>
          </vue-plyr>
        </Observer>
      </NoSSR>
    </div>
  </section>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import LazyPicture from './utils/LazyPicture'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import NoSSR from 'src/themes/zenith/node_modules/vue-no-ssr'

if (process.browser) {
  var VuePlyr = require('vue-plyr/dist/vue-plyr.ssr.js')
}

export default {
  props: ['item', 'items', 'images', 'products', 'pagePosition', 'siblings-components'],
  name: 'ambassadors_tile',
  mixins: [ReadyHook],
  components: {
    ModalProduct: () => import('./ModalProduct'),
    LazyPicture,
    VuePlyr,
    NoSSR
  },
  data () {
    return {
      pauseSlider: true,
      intervalSlider: null,
      currentSlide: 0,
      openModalProduct: false,
      dataModalProduct: null,
      played: false,
      injected: false,
      hideInfo: false,
      plyrOption: {
        controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'airplay', 'fullscreen', 'captions'],
        captions: {
          active: !!(this.item.subtitle && this.item.subtitle.srclang),
          language: (this.item.subtitle && this.item.subtitle.srclang) ? this.item.subtitle.srclang : 'en',
          fullscreen: {
            enabled: true,
            fallback: true,
            iosNative: true,
            container: null
          }
        }
      }
    }
  },
  mounted () {
    document.addEventListener('keyup', this.keyup)
    if (this.isMobile) {
      this.initSlider()
      this.pauseSlider = false
    }
  },
  destroyed () {
    document.removeEventListener('keyup', this.keyup)
  },
  computed: {
    localizedUrl () {
      const { url } = currentStoreView()
      return url || ''
    },
    isMobile () {
      return this.$store.state['zenith-ui'].menu.mobile
    }
  },
  methods: {
    onOpenModal () {
      this.openModalProduct = true
    },
    onCloseModal () {
      this.openModalProduct = false
    },
    toggleSlider () {
      if (this.pauseSlider) {
        this.initSlider()
      } else {
        clearTimeout(this.intervalSlider)
      }
      this.pauseSlider = !this.pauseSlider
    },
    initSlider () {
      this.intervalSlider = setInterval(() => {
        if (this.currentSlide < this.images.length - 1) {
          this.currentSlide++
        } else {
          this.currentSlide = 0
        }
      }, 2000)
    },
    keyup (e) {
      if (e.keyCode === 27 && this.item.type === 'video') {
        this.pauseVideo()
      }
    },
    playVideo () {
      if (this.$refs.plyr) {
        this.$refs.pop.style.display = 'flex'
        setTimeout(() => {
          this.played = true
          this.$refs.plyr.player.play()
          window.scrollTo({
            top: this.$el.getBoundingClientRect().top + window.scrollY
          })
          document.body.style.overflowY = 'hidden'
        }, 200)
      }
      this.hideInfo = true
    },
    pauseVideo () {
      if (this.$refs.plyr) {
        this.$refs.plyr.player.pause()
      }
      setTimeout(() => {
        this.played = false
        this.$refs.btn.focus()
      }, 200)
      setTimeout(() => {
        this.$refs.pop.style.display = 'none'
      }, 1000)
      document.body.style.overflowY = 'auto'
    },
    enter () {
      if (!this.injected) {
        this.injected = true
      }
    },
    leave () {
      if (this.$refs.plyr) {
        this.$refs.plyr.player.pause()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

section {
  position: relative;
  margin: 10rem 0;
  text-align: center;

  @include bp(max md) {
    margin: 4rem 0;
  }

  &.ambassadors-tile + .ambassadors-tile {
    margin: -10rem 0 10rem;

    @include bp(max md) {
      margin: -4rem 0 4rem;
    }
  }
}

.visual {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 100%;

  /deep/ img {
    max-width: 100%;
    position: absolute;
    object-fit: cover;
    height: 100%;
    left: 0;
    top: 0;

    @include bp(max md) {
      position: relative;
      height: auto;
    }
  }

  .slide {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    flex-grow: 1;
    opacity: 0;
    transition: all 0.4s ease-in-out;
    cursor: default;
    padding: 0;
    border: none;
    background: none;
    display: block;

    @include bp(max md) {
      cursor: pointer;
    }

    &.-active {
      opacity: 1;
    }
  }
}

.btn-preview {
  position: absolute;
  z-index: 10;
  top: 4rem;
  right: 4rem;
  height: 3.5rem;
  color: var(--zenith-theme-primary);
  border: none;
  margin: 0;
  overflow: hidden;
  padding: 1rem 1rem 1rem 0.8rem;
  border-radius: 3.5rem;
  background-color: var(--zenith-white);
  text-align: center;
  vertical-align: middle;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 3.5rem;
  cursor: pointer;
  transition: max-width 0.3s 0.15s ease-out;

  @include bp(max md) {
    top: 1rem;
    right: 1rem;
  }

  i {
    font-size: 2rem;
  }

  span {
    white-space: nowrap;
    text-transform: uppercase;
    margin-left: 1rem;
    opacity: 0;
    transition: opacity 0.3s 0s ease-in;
  }

  &:hover, &:active, &:focus {
    max-width: 20rem;
    transition: max-width 0.3s 0s ease-out;

    span {
      opacity: 1;
      transition: opacity 0.3s 0s ease-out;
    }

  }
}

.ambassadors {
  position: relative;
  overflow: hidden;
  min-height: 50vw;
  text-align: left;
  display: flex;
  align-items: center;

  &.-bg {
    background-color: #f3f3f3;

    @include bp(max md) {
      padding-bottom: 8rem;
    }
  }

  @include bp(max md) {
    height: auto;
    min-height: auto;
    max-height: none;
    display: flex;
    flex-direction: column-reverse;
  }

  img,
  video {
    position: absolute;
    object-fit: cover;
    height: 100%;
    width: 100%;

    @include bp(max md) {
      position: relative;
      width: 100%;
      height: 100vw;
    }
  }

  .content {
    @include bp(md) {
      flex: 0 0 55%;
      max-width: 55%;

      &.-right {
        margin-left: 45%;
      }
    }
  }

  & > .obs {
    position: absolute;
    width: 45%;
    top: 0;
    height: 100%;
    transform-style: preserve-3d;

    &.-left {
      left: 0;
    }

    &:not(.-left) {
      right: 0;
    }

    @include bp(max md) {
      position: relative;
      left: auto;
      right: auto;
      top: auto;
      width: 100%;
      height: calc(100vw * 1.25);
      transform: none;
      margin-bottom: 4rem;
    }
  }

  .container-fluid {
    height: 100%;

    .row {
      height: 100%;
      align-items: center;
    }
  }

  .info {
    width: 80%;
    max-width: none;
    margin: auto;
    padding: 4rem 0;

    @include bp(max md) {
      width: 100%;
      max-width: none;
      padding: 0 0 8rem;
    }

    .headline {
      display: block;
      text-align: center;
      margin-bottom: 2rem;

      @include bp(max md) {
        margin-bottom: 1rem;
      }
    }

    .subtitle {
      text-align: center;
      display: block;
      margin-bottom: 2rem;
      color: var(--zenith-theme-primary-lighter);
    }

    .title {
      margin-bottom: 2rem;
      text-align: center;
      color: #D6CABA;
    }

    .text {
      color: var(--zenith-grey);
      margin-top: 4rem;
      margin-bottom: 2rem;

      /deep/ a {
        color: var(--zenith-theme-primary);
        display: inline-block;
        position: relative;
        &:before {
          position: absolute;
          content: '';
          display: block;
          height: 0.1rem;
          width: 100%;
          background: var(--zenith-theme-primary);
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          transition: all 0.2s ease-in-out;
        }
        &:hover,
        &:focus {
          color: var(--zenith-theme-primary);

          &:before {
            width: 0;
          }
        }
      }
    }

    .btn {
      margin-top: 2rem;
    }
  }

}

.player {
  display: none;
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 200;
  top: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.6s ease-in-out;
  background: black;
  align-items: center;

  &.-show {
    opacity: 1;
    pointer-events: all;
  }

  /deep/ .obs {
    position: absolute;
    width: 100%;
  }

}

/deep/ .plyr {
  max-height: 100vh;

  &:not(.plyr__tab-focus) {
    .plyr__controls {
      opacity: 0;
    }

    &:hover {
      .plyr__controls {
        opacity: 1;
      }
    }
  }

  &--full-ui input[type='range'] {
    &.plyr__tab-focus {

      &::-webkit-slider-runnable-track {
        outline: 1px dashed var(--zenith-white);
      }

      &::-moz-range-track {
        outline: 1px dashed var(--zenith-white);
      }

      &::-ms-track {
        outline: 1px dashed var(--zenith-white);
      }
    }
  }

  &__controls {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);

    .plyr__tab-focus {
      outline: 1px dashed var(--zenith-white);
    }
  }

  &__poster {
    background-size: cover;
  }

  &__control--overlaid {
    background: var(--zenith-white);

    &:hover {
      svg {
        color: var(--zenith-white);
      }
    }

    svg {
      color: var(--zenith-theme-primary);
    }

  }
}

.hide-controls {
  /deep/ .plyr {
    .plyr__controls {
      opacity: 0 !important;
      pointer-events: none;
    }
  }
}

.btn-watch {
  margin-top: 4rem;
  position: relative;
  background: none;
  border: none;
  padding: 0;
  color: #D6CABA;
  text-transform: uppercase;
  display: block;

  @include bp(max md) {
    margin-top: 2rem;
  }

  .btn-autoPlay {
    bottom: -0.3rem;
    right: 0;
    position: relative;
    display: inline-block;
    background: #D6CABA;
    border-color: #D6CABA;
    box-shadow: none;
    vertical-align: bottom;
    margin-right: 1rem;

    &:before {
      border-left-color: #b2a089;
    }
  }
}

.close {
  position: absolute;
  z-index: 50;
  top: 2rem;
  right: 2rem;
  color: var(--zenith-white);
  background: none;
  border: none;
  font-size: em(30);

  @include bp(max md) {
    top: 1rem;
    right: 1rem;
    font-size: em(20);
  }

  i {
    display: block;
  }
}
</style>
